/* unplugin-vue-components disabled */import { render } from "./NotificationHeaderApp.vue?vue&type=template&id=f84d42c4&scoped=true&ts=true"
import script from "./NotificationHeaderApp.vue?vue&type=script&lang=ts"
export * from "./NotificationHeaderApp.vue?vue&type=script&lang=ts"

import "./NotificationHeaderApp.vue?vue&type=style&index=0&id=f84d42c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f84d42c4"]])

export default __exports__